import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { Link } from "react-router-dom";
import { FONTS, ROUTES, SECONDARY_COLOR, THIRD_COLOR } from "../constants";
import { LogoNameMainPage } from "../dashboard/Common/LogoNameMainPage";
import { LoadingAnimation } from "./loadingAnimations";
import { MainVideo } from "./MainVideo";

import { isMobile } from "react-device-detect";
const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		title: {
			fontFamily: FONTS,
			fontSize: isMobile ? "20px" : "40px",
			color: "rgba(255,255,255,0.95)",
			textAlign: isMobile ? "center" : "left",
			width: isMobile ? "100%" : "500px",
			marginTop: isMobile ? "-40px" : "0px",
		},
		subtitle: {
			fontFamily: FONTS,
			fontSize: isMobile ? "20px" : "25px",
			color: "rgba(255,255,255,0.65)",
			textAlign: "left",
			zIndex: 100,
			width: isMobile ? "100vw" : "500px",
			marginTop: "20px",
			paddingLeft: isMobile ? "10px" : "0px",
		},
		textAndButtonContainer: {
			alignItems: "center",
			display: "flex",
			flexDirection: "column",
			marginTop: isMobile ? "20px" : "100px",
		},
		tryItButton: {
			zIndex: 100,
			display: "flex",
			backgroundColor: THIRD_COLOR,
			marginTop: isMobile ? "30px" : "50px",
			marginRight: isMobile ? "auto" : "60px",
			"&:hover": {
				backgroundColor: "white",
			},
			transition: "0.2s",
		},
		tryItText: {
			color: "white",
			height: "50px",
			width: "180px",
			textAlign: "center",
			fontFamily: FONTS,
			lineHeight: "50px",
			fontSize: "22px",
			cursor: "pointer",
			"&:hover": {
				color: THIRD_COLOR,
			},
			transition: "0.2s",
			fontWeight: "bold",
		},
		tryItButtonOut: {
			zIndex: 100,
			display: "flex",
			backgroundColor: "white",
			marginTop: "30px",
			"&:hover": {
				backgroundColor: "white",
			},
			transition: "0.2s",
			//   border: "solid",
			//   borderColor: "white",
			borderRadius: "10px",
			borderWidth: "2px",
			marginRight: "200px",
		},
		tryItTextOut: {
			color: "black",
			height: "45px",
			width: "160px",
			textAlign: "center",
			fontFamily: FONTS,
			lineHeight: "45px",
			fontSize: "18px",
			cursor: "pointer",
			"&:hover": {
				color: SECONDARY_COLOR,
			},
			transition: "0.2s",
			fontWeight: "bold",
		},
		topBlockBackground: {
			backgroundImage:
				"radial-gradient(circle, #000000, #0f0309, #160714, #190d1d, #171228, #141329, #11142a, #0d152b, #0f1223, #0e0e1b, #0b0a12, #060606)",
			backgroundSize: "100vw 100%",
			height: isMobile ? "250px" : "700px",
			justifyContent: "center",
			display: "flex",
		},
		topBlockContainer: {
			width: isMobile ? "100vw" : "1500px",
			marginLeft: isMobile ? "0px" : "100px",
			overflow: "hidden",
		},
		blockItemsContainer: {
			display: "flex",
			flexDirection: isMobile ? "column" : "row",
			marginTop: "10px",
			justifyContent: "space-between",
		},
		topBar: {
			display: "flex",
			flexDirection: "row",
			justifyContent: isMobile ? "center" : "space-between",
		},
	});
});

function TryItButton() {
	const classes = useStyles();
	return (
		<div>
			<Link to={ROUTES.data_ingestion} style={{ textDecoration: "none" }}>
				<div className={classes.tryItButton}>
					<div className={classes.tryItText}>To Dashboard</div>
				</div>
			</Link>
		</div>
	);
}

function TopBar() {
	const classes = useStyles();

	return (
		<div className={classes.topBar}>
			<LogoNameMainPage></LogoNameMainPage>
			<div
				style={{
					marginTop: "-10px",
				}}
			>
				{isMobile ? (
					<div></div>
				) : (
					<div style={{ display: "flex", flexDirection: "row" }}>
						<Link
							to={ROUTES.data_ingestion}
							style={{ textDecoration: "none" }}
						></Link>
					</div>
				)}
			</div>
		</div>
	);
}

export function MainImage() {
	const classes = useStyles();
	return (
		<div className={classes.topBlockBackground}>
			<div className={classes.topBlockContainer}>
				<TopBar></TopBar>
				<div className={classes.blockItemsContainer}>
					<div className={classes.textAndButtonContainer}>
						<h1 className={classes.title}>
							The 100% Free ML Dashboard
						</h1>
						{isMobile ? (
							<div></div>
						) : (
							<h2 className={classes.subtitle}>
								Use Dash AI to build ML models, learn about ML
								and become data driven. No servers, 100% of your
								data stays on your computer.
							</h2>
						)}
						<TryItButton></TryItButton>
					</div>

					{isMobile ? (
						<div style={{}}></div>
					) : (
						<div style={{}}>
							<MainVideo></MainVideo>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
